export type CustomerLocationStatus =
  | 'idle'
  | 'requesting'
  | 'granted'
  | 'denied'
  | 'unavailable'
  | 'timeout'
  | 'unsupported';

export interface CustomerLocation {
  latitude: number;
  longitude: number;
  accuracy: number;
  timestamp: number;
}

export interface CustomerLocationState {
  status: CustomerLocationStatus;
  location?: CustomerLocation;
}

export const customerLocationOptions: PositionOptions = {
  enableHighAccuracy: false,
  timeout: 10_000,
  maximumAge: 5 * 60_000,
};

export function geolocationErrorStatus(error: Pick<GeolocationPositionError, 'code'>): CustomerLocationStatus {
  switch (error.code) {
    case 1:
      return 'denied';
    case 3:
      return 'timeout';
    case 2:
    default:
      return 'unavailable';
  }
}

export function toCustomerLocation(position: GeolocationPosition): CustomerLocation {
  return {
    latitude: position.coords.latitude,
    longitude: position.coords.longitude,
    accuracy: position.coords.accuracy,
    timestamp: position.timestamp,
  };
}
